import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  Chip,
} from "@mui/material";

interface ExportCSVModalProps {
  columns: { key: string; label: string }[];
  selectedColumns: string[];
  toggleColumn: (key: string) => void;
  setSelectedColumns: (cols: string[]) => void;
  open: boolean;
  onClose: () => void;
}

export default function ExportCSVModal({
  columns,
  selectedColumns,
  toggleColumn,
  setSelectedColumns,
  open,
  onClose,
}: ExportCSVModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      PaperProps={{
        sx: {
          width: 380,
        },
      }}
    >
      {/* HEADER */}
      <DialogTitle
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          fontWeight: 600,
          fontSize: "16px",
          py: 0.6,
          px: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Select Columns to Export
        <IconButton onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* ACTION BAR */}
      <Box
        sx={{
          px: 3,
          py: 1,
          display: "flex",
          gap: 1,
          borderBottom: "1px solid #eee",
        }}
      >
        <Chip
          label="Select All"
          color="primary"
          size="small"
          onClick={() => setSelectedColumns(columns.map((c) => c.key))}
        />

        <Chip
          label="Clear Columns"
          size="small"
          onClick={() => setSelectedColumns([])}
        />
      </Box>

      {/* BODY */}
      <DialogContent dividers>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
          }}
        >
          {columns.map((col) => (
            <FormControlLabel
              key={col.key}
              sx={{ m: 0 }}
              control={
                <Checkbox
                  size="small"
                  checked={selectedColumns.includes(col.key)}
                  onChange={() => toggleColumn(col.key)}
                />
              }
              label={col.label}
            />
          ))}
        </Box>
      </DialogContent>

      {/* FOOTER */}
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button variant="outlined" onClick={onClose} sx={{ borderRadius: 50 }}>
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={onClose}
          sx={{ borderRadius: 50 }}
          disabled={selectedColumns.length === 0}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
